module.exports = __webpack_public_path__ + "static/retail-7314b926c5136919cfee07ee1656b4af.png";